import { Icon } from '@loadsmart/miranda-react'
import { type ColorToken } from '@loadsmart/miranda-react/dist/tokens'

import { TrackingMethod, TrackingProvider } from '../../domain/Tracking'
import MacropointLogo from '../../ui/assets/macropoint-logo.png'
import TruckerToolsLogo from '../../ui/assets/trucker-tools-logo.png'

const ProvidersIcons: Record<TrackingProvider, JSX.Element> = {
  [TrackingProvider.TT]: (
    <img src={TruckerToolsLogo} alt="trucker tools" style={{ width: '16px', height: '16px' }} />
  ),
  [TrackingProvider.MACROPOINT]: (
    <img src={MacropointLogo} alt="macropoint" style={{ width: '16px', height: '16px' }} />
  ),
}

export function getProviderIcon(provider: TrackingProvider) {
  if (!(provider in ProvidersIcons)) return null
  return ProvidersIcons[provider]
}

export function getMethodIcon(method: TrackingMethod, color: ColorToken = 'color-text-secondary') {
  switch (method) {
    case TrackingMethod.API:
      return <Icon name="code" size="16px" color={color} />
    case TrackingMethod.ELD:
      return <Icon name="truck" size="16px" color={color} />
    case TrackingMethod.Mobile:
      return <Icon name="phone" size="16px" color={color} />
    case TrackingMethod.EDI:
      return <Icon name="plugs" size="16px" color={color} />
    default:
      return <Icon name="hand-tap" size="16px" color={color} />
  }
}
